import { useToastsContext } from '@fourthwall/components';
import React, { createContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTiersQuery } from '@modules/Dashboard/Memberships/modules/Perks/hooks/useTiersQuery';
import { routing } from '@utils/routing';
import { useBadgeForm } from '../../hooks/useBadgeForm/useBadgeForm';
import { useCreateCustomBadgeMutation } from '../../hooks/useCreateCustomBadgeMutation';
import { getIconPayload, getRulesPayload } from '../../utils';
export const BadgeCreateContext = createContext(undefined);
export const BadgeCreateProvider = ({ children }) => {
    const navigate = useNavigate();
    const toast = useToastsContext();
    const { tiersQuery } = useTiersQuery();
    const { createCustomBadgeMutation } = useCreateCustomBadgeMutation();
    const { form, availableRules, hasAnyRules, hasAvailableRules, hasEmptyRule, getRuleComponent } = useBadgeForm({
        onSubmit: (values) => {
            createCustomBadgeMutation.mutate([
                {
                    text: values.text,
                    icon: getIconPayload(values.emoji),
                    borderColor: values.borderColor,
                    backgroundColor: values.backgroundColor,
                    textColor: values.textColor,
                    rules: getRulesPayload(values),
                    removeWhenRulesNoLongerMet: !!values.removeWhenRulesNoLongerMet,
                    manuallyAssignedSupporterIds: values.giveToSelectedMembers
                        ? values.manuallyAssignedSupporters.map((supporter) => supporter.id)
                        : undefined,
                },
            ], {
                onSuccess: () => {
                    navigate(routing.memberships.settings.badges.self);
                    toast.notify('Badge has been created successfully! It may take up to 2 minutes to reflect changes', { type: 'success' });
                },
            });
        },
    });
    const value = useMemo(() => ({
        form,
        tiers: tiersQuery.data?.tiers,
        availableRules,
        hasEmptyRule,
        hasAnyRules,
        hasAvailableRules,
        isLoading: createCustomBadgeMutation.isLoading,
        getRuleComponent,
    }), [
        form,
        tiersQuery.data?.tiers,
        availableRules,
        hasEmptyRule,
        hasAnyRules,
        hasAvailableRules,
        createCustomBadgeMutation.isLoading,
        getRuleComponent,
    ]);
    return React.createElement(BadgeCreateContext.Provider, { value: value }, children);
};
